import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { addRole } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { RoleProvider } from '../../../RoleContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import RoleEditContent from '../../../components/Dashboard/RoleEditContent'


const SingleRoleAdd = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Roles.List.AddRole.Title' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={addRole.image}
           description={intl.formatMessage({ id: 'Roles.List.AddRole.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall, adminSectionType }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ? <Layout content={
                <RoleProvider pageAction={'add'} adminSectionType={adminSectionType}
                              handleNotificationCall={handleNotificationCall}>
                  <RoleEditContent adminSectionType={adminSectionType}
                                   pageTitle={<FormattedMessage id='Roles.List.AddRole.Title'/>}/>
                </RoleProvider>
              }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SingleRoleAdd

